import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Grid } from '@mui/joy';
import './AddQueryToSchedule.css';
import CustomTextArea from '../../../../../Components/custom_components/CustomTextArea/CustomTextArea';
import ActionButton from '../../../../../Components/custom_components/CustomButtons/ActionButton/ActionButton';
import CustomSelectDropdown from '../../../../../Components/custom_components/CustomSelectDropdown/CustomSelectDropdown';
import { get_schedule_assignees } from '../../../../../config/Worksite/scheduleApis';

const AddQueryToSchedule = ({ handleSave, scheduleInfo = {}, isButtonDisabled = false, }) => {

    const [workforceListing, setWorkforceListing] = useState([]);

    const formik = useFormik({
        initialValues: {
            scheduleID: scheduleInfo?.id || '',
            query_text: '',
            supervisorID: '',
        },
        validationSchema: Yup.object({
            query_text: Yup.string().required('Query description is required'),
            supervisorID: Yup.string().required('Supervisor is required'),
        }),
        enableReinitialize: true,
        onSubmit: (values) => {
            handleSave(values);
        },
    });

    const fetchWorkForces = async () => {
        try {
            const params = {
                scheduleID: scheduleInfo?.id,
                status: 1 //for active users only
            }
            const response = await get_schedule_assignees(params);
            if (response?.status === 'success') {
                const transformed = response?.data?.map(item => ({
                    label: item?.name,
                    value: item?.id
                }));
                setWorkforceListing(transformed || []);
            }
        } catch (error) {
            console.error("Error fetching supervisors:", error);
            setWorkforceListing([]);
        }
    };

    useEffect(() => {
        fetchWorkForces();
    }, []);

    const handleReset = () => formik.resetForm();

    return (
        <div className="query-form-container">
            <Grid container spacing={2}>
                {/* Supervisor Dropdown */}
                <Grid item xs={12}>
                    <div className="query-form-mid-container">
                        <div className="query-label-container">
                            <span className="add-query-label">
                                Employee<span className="label_required_remark ">*</span>
                            </span>
                        </div>
                        <div className="query-custom-textfield-container">
                            <CustomSelectDropdown
                                name="supervisorID"
                                placeholder="Select Employee"
                                options={workforceListing}
                                value={workforceListing.find(option => option.value === formik.values.supervisorID) || ''}
                                onChange={option => formik.setFieldValue("supervisorID", option ? option.value : "")}
                                onBlur={formik.handleBlur}
                                error={formik.touched.supervisorID && Boolean(formik.errors.supervisorID)}
                                helperText={formik.touched.supervisorID && formik.errors.supervisorID}
                                isMulti={false}
                                width="100%"
                            />
                        </div>
                    </div>
                </Grid>

                {/* Query Description */}
                <Grid item xs={12}>
                    <div className="query-form-mid-container">
                        <div className="query-label-container">
                            <span className="add-query-label">
                                Description<span className="label_required_remark ">*</span>
                            </span>
                        </div>
                        <div className="query-custom-textfield-container">
                            <CustomTextArea
                                id="query_text"
                                name="query_text"
                                placeholder="Enter query description"
                                rows={5}
                                value={formik.values.query_text}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.query_text && Boolean(formik.errors.query_text)}
                                helperText={formik.touched.query_text && formik.errors.query_text}
                                maxLength={500}
                            />
                        </div>
                    </div>
                </Grid>
            </Grid>

            <div className="query-form-bottom-action-buttons-container">
                <ActionButton onClick={handleReset} label="Reset" btnType="outlined" />
                <ActionButton
                    onClick={formik.handleSubmit}
                    btnDisable={isButtonDisabled}
                    label="Submit"
                    btnType="primary"
                />
            </div>
        </div>
    );
};

export default AddQueryToSchedule;
